module.exports = __webpack_public_path__ + "static/media/expressiveCactusRick-large.6bf2bd5c.jpg";